import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["activeId", "showLogo", "buttonProps", "menuList", "fixed", "onCallbackMenu"],
  _excluded2 = ["id", "icon", "showBadge", "title", "redirect"];
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavbarContainer, MenuHeader, MenuItem, StyledButton, MenuList, MenuItemText, MenuItemLink, LogoContainer, BadgeSpan, MenuTag } from './styles';
import Logo, { SlimLogo } from '../Logo';
import * as Icons from '../Icons';
var _ref2 = /*#__PURE__*/React.createElement(SlimLogo, null);
var _ref3 = /*#__PURE__*/React.createElement(Logo, {
  width: 108,
  height: 48
});
var SidebarMenu = function SidebarMenu(_ref) {
  var activeId = _ref.activeId,
    showLogo = _ref.showLogo,
    buttonProps = _ref.buttonProps,
    menuList = _ref.menuList,
    fixed = _ref.fixed,
    onCallbackMenu = _ref.onCallbackMenu,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    collapsed = _React$useState2[0],
    setCollapse = _React$useState2[1];
  var onMouseOverHandler = React.useCallback(function () {
    return !fixed && setCollapse(false);
  }, [fixed]);
  var onMouseOutHandler = React.useCallback(function () {
    return !fixed && setCollapse(true);
  }, [fixed]);
  useEffect(function () {
    if (fixed) setCollapse(false);
  }, []);
  var _ref5 = /*#__PURE__*/React.createElement(MenuTag, {
    collapsed: collapsed,
    text: "Novo"
  });
  return /*#__PURE__*/React.createElement(NavbarContainer, _extends({
    onClick: function onClick(e) {
      return onCallbackMenu(e);
    },
    onMouseEnter: onMouseOverHandler,
    onMouseLeave: onMouseOutHandler,
    collapsed: collapsed
  }, props), /*#__PURE__*/React.createElement(MenuHeader, {
    showlogo: true
  }, showLogo && /*#__PURE__*/React.createElement(LogoContainer, {
    id: "menu-logo"
  }, collapsed ? _ref2 : _ref3), buttonProps && /*#__PURE__*/React.createElement(StyledButton, {
    variant: "primary",
    collapsed: collapsed,
    size: "small",
    id: buttonProps.id,
    "data-redirect": buttonProps.redirect || ''
  }, Icons && /*#__PURE__*/React.createElement(Icons[buttonProps.icon]), /*#__PURE__*/React.createElement("span", null, buttonProps.title))), /*#__PURE__*/React.createElement(MenuList, null, menuList && menuList.map(function (_ref4) {
    var id = _ref4.id,
      icon = _ref4.icon,
      showBadge = _ref4.showBadge,
      title = _ref4.title,
      redirect = _ref4.redirect,
      rest = _objectWithoutProperties(_ref4, _excluded2);
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: id
    }, /*#__PURE__*/React.createElement(MenuItemLink, _extends({
      id: id,
      active: activeId === id,
      "data-redirect": redirect || ''
    }, rest), showBadge && /*#__PURE__*/React.createElement(BadgeSpan, {
      collapsed: collapsed,
      showBadge: showBadge
    }), Icons && /*#__PURE__*/React.createElement(Icons[icon]), /*#__PURE__*/React.createElement(MenuItemText, {
      collapsed: collapsed
    }, " ", title, " "), showBadge && _ref5));
  })));
};

/* eslint-disable react/forbid-prop-types */
process.env.NODE_ENV !== "production" ? SidebarMenu.propTypes = {
  fixed: PropTypes.bool,
  showLogo: PropTypes.bool.isRequired,
  activeId: PropTypes.string.isRequired,
  buttonProps: PropTypes.object.isRequired,
  menuList: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCallbackMenu: PropTypes.func.isRequired
} : void 0;
SidebarMenu.defaultProps = {
  fixed: false
};
export default SidebarMenu;